<template>
  <div class="app-page">
    <PageHeader />
    <div class="application-page-container">
      <section>
        <div class="btn-action-group">
          <router-link :to="{ path: `/master/permission/manager_detail/new` }">
            <a-button type="primary">
              <PlusOutlined />
              {{ $t('admin.Add New Review Manager') }}
            </a-button>
          </router-link>
        </div>
        <a-input-search
          clss="input-search-panel"
          v-model:value="keyword"
          allow-clear
          :placeholder="$t('admin.Review Manager')"
          :loading="loading"
          @search="onSearch"
        />
      </section>
      <section class="application-counter">
        <div class="counter-text">
          {{ $t('admin.Total') }}: {{ pagination.total }}
          {{
            pagination.total > 1
              ? $t('admin.Review Managers')
              : $t('admin.Review Manager')
          }}
        </div>
        <div class="page-pagination">
          <a-pagination
            @change="fetchData"
            v-model:current="pagination.current"
            :total="pagination.total"
            v-model:pageSize="pagination.pageSize"
            :pageSizeOptions="pagination.pageSizeOptions"
            size="small"
            show-less-items
            show-size-changer
            show-quick-jumper
          />
        </div>
      </section>
      <a-table
        class="job-table"
        :rowKey="(record) => record.id"
        :columns="columns"
        :data-source="dataSource"
        @change="onChange"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
        <template v-slot:headerCell="{ title }">
          {{ $t('admin.' + title) }}
        </template>
        <template v-slot:bodyCell="{ record, column }">
          <template v-if="column.key === 'lion_id'">
            <span
              :class="{ highlight: record.lion_id.trim() == keyword.trim() }"
            >
              {{ record.lion_id }}
            </span>
          </template>
          <template v-if="column.key === 'name'">
            <span :class="{ highlight: record.name.trim() == keyword.trim() }">
              {{ record.name }}
            </span>
          </template>
          <template v-if="column.key === 'action'">
            <router-link
              :to="{ path: `/master/permission/manager_detail/${record.id}` }"
            >
              <a-button block type="link">{{ $t('admin.Edit') }}</a-button>
            </router-link>
            <a-button type="link" block @click="dualRole(record)">
              {{ $t('admin.Dual Role') }}
            </a-button>
            <a-button type="link" block @click="disableAccount(record)">
              {{ $t('admin.Cancel Account') }}
            </a-button>
          </template>
        </template>
      </a-table>
      <div class="table-pagination">
        <div></div>
        <a-pagination
          @change="fetchData"
          v-model:current="pagination.current"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          size="small"
          show-less-items
          show-size-changer
          show-quick-jumper
        />
      </div>
    </div>
    <a-modal
      v-model:visible="dualRoleDialogVisible"
      centered
      width="1480px"
      :title="$t('admin.Dual Role')"
      class="employee-uploade-dialog"
    >
      <template #footer>
        <a-button type="default" @click="dualRoleDialogVisible = false">
          {{ $t('admin.Cancel') }}
        </a-button>
        <a-button
          key="submit"
          html-type="submit"
          type="primary"
          :loading="loadingDual"
          @click="formFinish"
        >
          {{ $t('admin.Dual') }}
        </a-button>
      </template>
      <a-form
        layout="vertical"
        ref="form"
        :model="formData"
        @finish="formFinish"
        :rules="validateRules"
      >
        <section>
          <h2 class="section-title">{{ $t('admin.Employee') }}</h2>
          <a-form-item :label="$t('admin.Employee LLID')" name="a_LLID">
            <a-input
              v-model:value="formData.a_LLID"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee CS ID')" name="a_LLID">
            <a-input
              v-model:value="formData.cs_id"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee English Name')" name="a_Name">
            <a-input
              v-model:value="formData.a_Name"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Employee Email Address')"
            name="a_Email"
          >
            <a-input
              v-model:value="formData.a_Email"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee Title')" name="a_Title">
            <a-input
              v-model:value="formData.a_Title"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Level1')" name="a_Brand">
            <a-input
              v-model:value="formData.a_Brand"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Level2')" name="a_Role">
            <a-input
              v-model:value="formData.a_Role"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Level3')" name="a_Level">
            <a-input
              v-model:value="formData.a_Level"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Job Grading')" name="a_Grading">
            <a-select
              ref="select"
              v-model:value="formData.a_Grading"
              :placeholder="$t('admin.Please Select')"
            >
              <a-select-option
                v-for="grading in ['O', 'P', 'Q', 'R', 'S']"
                :key="grading"
                :value="grading"
              >
                {{ grading }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Location of Employee')"
            name="a_Location"
          >
            <a-select
              ref="select"
              v-model:value="formData.a_Location"
              :placeholder="$t('admin.Please Select')"
            >
              <a-select-option
                v-for="location in ['Beijing', 'Shanghai', 'Guangzhou']"
                :key="location"
                :value="location"
              >
                {{ location }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('admin.HFM Code')" name="HFMCode">
            <a-input
              v-model:value="formData.HFMCode"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Department/Client')"
            name="departmentClient"
          >
            <a-input
              v-model:value="formData.departmentClient"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Parent Function')"
            name="parentFunction"
          >
            <a-input
              v-model:value="formData.parentFunction"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Child Function')" name="childFunction">
            <a-input
              v-model:value="formData.childFunction"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Join Date')" name="joinDate">
            <a-date-picker
              v-model:value="formData.joinDate"
              :placeholder="$t('admin.Please Input')"
            />
          </a-form-item>
        </section>
        <section>
          <h2 class="section-title">{{ $t('admin.Review Manager') }}</h2>
          <a-row>
            <a-form-item
              :label="$t('admin.LLID of Review Manager')"
              name="b_LLID"
            >
              <a-input
                v-model:value="formData.b_LLID"
                :placeholder="$t('admin.Please Input')"
                @blur="loadReviewManager"
              ></a-input>
            </a-form-item>
            <span class="loading-small" v-if="loadingLM">loading...</span>
            <span class="loading-small error-small" v-if="wrongLM">
              {{
                isEn
                  ? 'Please enter the correct manager LionID'
                  : '请输入正确的狮厂经理 LionID'
              }}
            </span>
          </a-row>
          <a-form-item
            :label="$t('admin.Review Manager Name(EN)')"
            name="b_Name"
          >
            <a-input
              v-model:value="formData.b_Name"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Review Manager Email Address')"
            name="b_Email"
          >
            <a-input
              v-model:value="formData.b_Email"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Review Manager Title')" name="b_Title">
            <a-input
              v-model:value="formData.b_Title"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Brand of Review Manager')"
            name="b_Brand"
          >
            <a-input
              v-model:value="formData.b_Brand"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
        </section>
        <section>
          <h2 class="section-title">{{ $t('admin.HRBP') }}</h2>
          <a-row>
            <a-form-item :label="$t('admin.LLID of HRBP')" name="c_LLID">
              <a-input
                v-model:value="formData.c_LLID"
                :placeholder="$t('admin.Please Input')"
                @blur="loadHRBP"
              ></a-input>
            </a-form-item>
            <span class="loading-small" v-if="loadingHRBP">loading...</span>
            <span class="loading-small error-small" v-if="wrongHRBP">
              {{
                isEn
                  ? 'Please enter the correct HRBP LionID'
                  : '请输入正确的HRBP LionID'
              }}
            </span>
          </a-row>
          <a-form-item :label="$t('admin.HRBP Name (EN)')" name="c_Name">
            <a-input
              v-model:value="formData.c_Name"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.HRBP Email Address')" name="c_Email">
            <a-input
              v-model:value="formData.c_Email"
              :placeholder="$t('admin.Please Input')"
              disabled
            ></a-input>
          </a-form-item>
        </section>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PlusOutlined } from '@ant-design/icons-vue'
import PageHeader from '../components/PageHeader.vue'
import {
  getManagerPermissionList,
  getManagerInfo,
  getHRBPInfo,
  addEmployeeIdentityRightsForManager,
} from '@/api/admin'
import { message, Modal } from 'ant-design-vue'
import { disableManagerAccount } from '@/api/admin'
// import { FilterOutlined } from '@ant-design/icons-vue'
import Empty from '@/components/Empty'
import dayjs from 'dayjs'
import { toRaw } from '@vue/reactivity'

export default {
  name: 'Index',
  components: {
    PageHeader,
    PlusOutlined,
    Empty,
  },
  data() {
    const validateRules = {}
    const inputFileds = [
      'a_LLID',
      'a_Name',
      'a_Title',
      'a_Location',
      // 'b_Name',
      // 'b_Title',
      'a_Brand',
      'a_Role',
      'b_LLID',
      // 'c_Name',
      'c_LLID',
      'HFMCode',
      'departmentClient',
      'parentFunction',
      'childFunction',
    ]
    const dateFileds = ['joinDate']
    dateFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          validator: (_rule, value) => {
            if (value == null || !value.isValid()) {
              return Promise.reject(this.$t('admin.Please Input'))
            } else {
              return Promise.resolve()
            }
          },
          trigger: 'change',
        },
      ]
    })
    const selectFileds = ['a_Grading']
    const emailFields = ['a_Email']
    emailFields.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Input'),
          trigger: 'blur',
        },
        {
          pattern:
            /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: this.$t('admin.Incorrect mailbox format'),
        },
      ]
    })
    inputFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Input'),
          trigger: 'blur',
        },
      ]
    })
    selectFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Select'),
          trigger: 'blur',
        },
      ]
    })
    return {
      validateRules,
      loading: false,
      uploadDataUrl: '/api/RoleC/Import',
      keyword: '',
      filteredInfo: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
      },
      dataSource: [],
      renameVisible: false,
      fileTemplate: {},
      dualRoleDialogVisible: false,
      formData: {},
      loadingLM: false,
      loadingHRBP: false,
      wrongLM: false,
      wrongHRBP: false,
      loadingDual: false,
      currentManager: null,
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'Lion ID',
          key: 'lion_id',
          dataIndex: 'lion_id',
        },
        {
          title: 'Name',
          key: 'name',
          dataIndex: 'name',
        },
        {
          title: 'Current Brand',
          key: 'brand',
          dataIndex: 'brand',
        },
        {
          title: 'Title',
          key: 'title',
          dataIndex: 'title',
        },
        {
          title: 'Action',
          key: 'action',
          width: 150,
        },
      ]
    },
    ...mapGetters({
      ability: 'acl/ability',
      Authorization: 'user/accessToken',
    }),
    canCancel() {
      const ability = this.ability.find(
        (item) => item.key === 'can_cancel_account'
      )
      return ability.value
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const params = {
        pageSize: this.pagination.pageSize || 10,
        pageNum: this.pagination.current || 1,
        keywords: this.keyword,
      }
      this.loading = true
      getManagerPermissionList(params)
        .then((res) => {
          if (res.code === 200) {
            this.dataSource = res.data
            this.pagination.total = res.page.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    dualRole(record) {
      this.currentManager = record
      console.log(this.currentManager)
      this.formData = {
        ...this.formData,
        a_LLID: this.currentManager.lion_id,
        a_Name: this.currentManager.name,
        a_Email: this.currentManager.email,
        a_Title: this.currentManager.title,
        a_Role: this.currentManager.brand,
      }
      const that = this
      Modal.confirm({
        title: this.$t('admin.Dual Role'),
        okText: this.$t('admin.Dual'),
        cancelText: this.$t('admin.Cancel'),
        closable: true,
        content: this.$t(
          'admin.Are you sure to add employee identity rights for this manager?'
        ),
        onOk() {
          try {
            that.dualRoleDialogVisible = true
          } catch (e) {
            message.error(e.msg)
          }
        },
      })
    },
    disableAccount(record) {
      let that = this
      Modal.confirm({
        title: this.$t('admin.Cancel Account'),
        okText: this.$t('admin.Yes'),
        cancelText: this.$t('admin.No'),
        closable: true,
        content: this.$t(
          'admin.Are you sure you want to cancel the current account?'
        ),
        onOk() {
          return disableManagerAccount(record.id)
            .then((res) => {
              if (res.code === 200) {
                record.is_block = true
                that.fetchData()
              } else {
                message.info(res.msg)
              }
            })
            .catch((res) => {
              message.warning(res.msg)
            })
        },
      })
    },
    onSearch() {
      this.pagination.current = 1
      return this.fetchData()
    },
    onChange() {
      return this.fetchData()
    },
    async loadReviewManager() {
      this.loadingLM = true
      try {
        const res = await getManagerInfo(this.formData.b_LLID)
        if (res.data == null) {
          this.formData = {
            ...this.formData,
            b_Name: '',
            b_Brand: '',
            b_Title: '',
            b_Email: '',
          }
          this.wrongLM = true
        } else {
          this.formData = {
            ...this.formData,
            b_Name: res.data.name,
            b_Brand: res.data.brand,
            b_Title: res.data.title,
            b_Email: res.data.email,
          }
          this.wrongLM = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLM = false
      }
    },
    async loadHRBP() {
      this.loadingHRBP = true
      try {
        const res = await getHRBPInfo(this.formData.c_LLID)
        if (res.data == null) {
          this.formData = {
            ...this.formData,
            c_Name: '',
            c_Email: '',
          }
          this.wrongHRBP = true
        } else {
          this.formData = {
            ...this.formData,
            c_Name: res.data.name,
            c_Email: res.data.email,
          }
          this.wrongHRBP = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingHRBP = false
      }
    },
    async formFinish() {
      const that = this
      this.loadingDual = true
      const data = this.formData
      console.log(this.validateRules)

      // console.log(data)
      // data.joinDate = dayjs(data.joinDate).format('YYYY-MM-DD')
      // console.log(data.joinDate)
      try {
        await this.$refs.form.validate()
        await addEmployeeIdentityRightsForManager({
          ...data,
          mId: this.currentManager.id,
        })
        that.dualRoleDialogVisible = false
        message.success(
          that.$t(
            'admin.You have successfully added employee privileges for this manager'
          )
        )
      } catch (err) {
        if (err.msg) {
          message.error(err.msg)
        }
      } finally {
        this.loadingDual = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import url('@/styles/params.less');

.application-page-container {
  margin: @app-conetent-margin;
  background-color: white;
  padding: 24px;
  section {
    display: flex;
    justify-content: space-between;
  }

  .input-search-panel {
    width: 285px;
  }

  .application-counter {
    padding: 24px 0;
    align-items: center;
    .counter-text {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      span {
        margin-right: 12px;
      }
    }
  }
}
.btn-groups {
  .ant-btn {
    display: block;
  }
}
.table-pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.form-field-title {
  font-size: 14px;
  font-family: Helvetica;
  color: #333333;
  line-height: 22px;
  margin: 8px 0;
}
:deep {
  .table-pagination,
  .page-pagination {
    .ant-pagination-item-active {
      a {
        color: white;
      }
      background-color: @primary-color;
    }
  }
}
span.highlight {
  color: @primary-color;
  font-weight: bold;
}

.ant-form-vertical .ant-form-item {
  display: inline-block;
  width: 230px;
  margin-right: 70px;
}
.loading-small {
  margin-top: 35px;
}
.error-small {
  color: red;
}
</style>
